var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import styled from "styled-components";
import { TextButton } from "@irati/ui/src/Button";
import Icon, { IconTypes } from "@irati/ui/src/Icon";
export var ExpanderArrow = styled(Icon).attrs(function (_a) {
    var theme = _a.theme;
    return ({
        size: 24,
        color: theme.colors.utility.subdued,
        icon: IconTypes.chevronDown
    });
})(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  margin: ", ";\n  ", ";\n"], ["\n  margin: ", ";\n  ", ";\n"
    // Empty, but exporting so it can be extended on by programmer
])), function (_a) {
    var theme = _a.theme;
    return theme.spacing.oneAndHalf;
}, function (_a) {
    var isExpanded = _a.isExpanded;
    return isExpanded && "transform: rotate(180deg);";
});
// Empty, but exporting so it can be extended on by programmer
export var ExpanderContent = styled.div(templateObject_2 || (templateObject_2 = __makeTemplateObject([""], [""])));
export var HeaderWrapper = styled(TextButton)(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  ", "\n  min-height: 48px;\n"], ["\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  ", "\n  min-height: 48px;\n"])), function (_a) {
    var fullWidth = _a.fullWidth;
    return fullWidth && "width: 100%;";
});
var templateObject_1, templateObject_2, templateObject_3;
